/* English — source-of-truth dictionary. All keys must exist here.
 * Other locales fall back to this file when a key is missing. */

const en = {
  /* ─── Home ─── */
  'home.eyebrow':         '🌍 geoplay24.com',
  'home.title':           'Geo Play 24',
  'home.subtitle.line1':  '7 immersive geography games.',
  'home.subtitle.line2':  '1 World. 5 Levels. Endless wonder.',
  'home.tagline.line1':   'Seven games, one planet.',
  'home.tagline.line2':   'Discover every corner of Earth — compete, score points, conquer your empire.',
  'home.footer.company':  'Company',
  'home.footer.legal':    'Legal',
  'home.footer.about':    'About us',
  'home.footer.contact':  'Contact',
  'home.footer.github':   'GitHub',
  'home.footer.tiktok':   'TikTok',
  'home.footer.x':        'X / Twitter',
  'home.footer.privacy':  'Privacy',
  'home.footer.terms':    'Terms',
  'home.footer.cookies':  'Cookies',
  'home.copy':            'powered by: © 2026 Janek @ DevFlow C ™️',
  'home.beta.title':      'Join the early testers of our Android app',
  'home.beta.text':       'Get a Founder badge, lifetime Premium, and a chance at the raffle prizes above.',
  'home.beta.cta':        'BETA program',

  /* ─── Common UI ─── */
  'common.start':         'Start',
  'common.startBig':      '▶ Start',
  'common.back':          'Back',
  'common.home':          'Home',
  'common.howToPlay':     'How to play',
  'common.gotIt':         'Got it — back to game',
  'common.next':          'Next',
  'common.restart':       'Restart',
  'common.tryAgain':      'Try Again',
  'common.playAgain':     'Play Again',
  'common.mainMenu':      'Main Menu',
  'common.quit':          'Quit',
  'common.play':          'Play',
  'common.unlock':        '🔒 Unlock with Premium',
  'common.language':      'Language',

  /* ─── Rules sections ─── */
  'rules.kicker.goal':         'Goal',
  'rules.kicker.howToPlay':    'How to play',
  'rules.kicker.levels':       'Levels',
  'rules.kicker.tips':         'Tips',
  'rules.gameNotFound':        'Game not found',
  'rules.points':              'pts',

  /* ─── Game cards ─── */
  'games.origin.title':       'Origin Hunt',
  'games.origin.tagline':     'Find your roots',
  'games.origin.description': 'A random Street View location somewhere in the world. Find the spot on the map. 100 km → 1 km accuracy across 5 levels.',
  'games.hunt.title':         'Object Hunt',
  'games.hunt.tagline':       'GPS-style treasure hunt',
  'games.hunt.description':   'Dropped near a real landmark. Walk the Street View to find it. The compass gets less and less helpful as the levels rise.',
  'games.photo.title':        'Photo Detective',
  'games.photo.tagline':      'Read the clues',
  'games.photo.description':  'One static Street View shot — no panning, no movement. Read signs, plants, sun direction. From 30 sec down to a 5 sec flash.',
  'games.pangaea.title':      'Pangaea Puzzle',
  'games.pangaea.tagline':    'Reassemble the Earth',
  'games.pangaea.description':'Continents and islands floating around a 3D globe. Drag them back into place — current positions, or the ancient Pangaea.',

  /* ─── Origin Hunt rules ─── */
  'rules.origin.goal': 'You are dropped into a random Street View somewhere on Earth. Pin yourself on the world map as accurately as you can.',
  'rules.origin.step1': 'Look around the panorama. Read signs, count traffic lanes, watch the sky for sun direction.',
  'rules.origin.step2': 'Click the minimap to drop a pin where you think you are.',
  'rules.origin.step3': 'Submit. The closer your pin to the real spot, the more points.',
  'rules.origin.step4': 'Levels chain — pass the distance threshold to unlock the next.',
  'rules.origin.level1': 'within 100 km',
  'rules.origin.level2': 'within 50 km',
  'rules.origin.level3': 'within 25 km',
  'rules.origin.level4': 'within 10 km',
  'rules.origin.level5': 'within 1 km',
  'rules.origin.tip1': 'Driving side, plate format and road-marking colours give the country away fast.',
  'rules.origin.tip2': 'Vegetation + sun height narrow the latitude. Street signs nail the city.',
  'rules.origin.tip3': 'Pinpointing Master Geographer (L5 = 1 km) is brutal — most runs end at L3 or L4.',

  /* ─── Object Hunt rules ─── */
  'rules.hunt.goal': 'You are placed in Street View near a real-world landmark. Walk the panorama until you stand on top of it. The compass gets less helpful as the levels rise.',
  'rules.hunt.step1': 'Read the target name in the top bar.',
  'rules.hunt.step2': 'Use the compass arrow + distance readout to aim yourself in the right direction.',
  'rules.hunt.step3': 'Click the chevrons to walk through Street View.',
  'rules.hunt.step4': 'When you are inside the find-zone, the "I found it" button activates — press it to score.',
  'rules.hunt.level1': '5 km away · 10 min · world-famous · arrow + exact distance · 100 m find-zone',
  'rules.hunt.level2': '15 km · 12 min · world-famous · arrow + rounded distance',
  'rules.hunt.level3': '25 km · 12 min · country-famous · compass only, no distance',
  'rules.hunt.level4': '50 km · 15 min · country-famous · hot/cold cue',
  'rules.hunt.level5': '50 km · 10 min · obscure · POI name only, no GPS',
  'rules.hunt.tip1': 'On L4–L5 you get 3 Compass Pings — flashes of the arrow, use them sparingly.',
  'rules.hunt.tip2': 'Halfway-checkpoint bonus: passing the midway distance adds 2 minutes.',
  'rules.hunt.tip3': 'When you have only the name, search your memory or look at the surroundings — many landmarks are visually distinctive from blocks away.',

  /* ─── Photo Detective rules ─── */
  'rules.photo.goal': 'You see one static Street View frame — no panning, no movement. From signs, plants, sun direction and road markings, deduce where on Earth it was taken.',
  'rules.photo.step1': 'You pick a region first (World, Europe, Asia, etc.) — that sets the haystack.',
  'rules.photo.step2': 'A photo flashes for a fixed observation window. Use every second.',
  'rules.photo.step3': 'After the timer ends, a map appears. Drop a pin on your best guess.',
  'rules.photo.step4': 'Closer pin = more points. The result screen replays the photo so you can see what you missed.',
  'rules.photo.level1': '30 sec to study · 1 000 km accuracy',
  'rules.photo.level2': '20 sec · 500 km',
  'rules.photo.level3': '15 sec · 250 km',
  'rules.photo.level4': '10 sec · 100 km',
  'rules.photo.level5': '5 sec flash · 50 km',
  'rules.photo.tip1': 'Language on signs is the fastest clue. Even one word usually pins a country.',
  'rules.photo.tip2': 'Sun direction tells you which way is south (north hemisphere) or north (south hemisphere).',
  'rules.photo.tip3': 'Power-line shape, road markings, and license plates are surprisingly diagnostic.',

  /* ─── Pangaea Puzzle rules ─── */
  'rules.pangaea.goal': 'A 3D Earth, six continents. Place each one within the level\'s angular tolerance — at its modern position, or where it sat 300 million years ago in Pangaea.',
  'rules.pangaea.step1': 'Pick a continent from the right-side list.',
  'rules.pangaea.step2': 'Click on the globe where you think it belongs.',
  'rules.pangaea.step3': 'If you are within tolerance → snaps into place. Otherwise → red feedback, try again.',
  'rules.pangaea.step4': '3 attempts per continent. Place at least 5 of 6 to advance to the next level.',
  'rules.pangaea.level1': 'Continents · today · 25° tolerance',
  'rules.pangaea.level2': 'today · 18° tolerance',
  'rules.pangaea.level3': 'today · 12° pinpoint',
  'rules.pangaea.level4': 'Pangaea · ancient · 25° tolerance',
  'rules.pangaea.level5': 'Pangaea · ancient · 18° pinpoint',
  'rules.pangaea.tip1': 'Drag the globe to rotate. Scroll to zoom.',
  'rules.pangaea.tip2': 'On Pangaea levels, the continents were clumped in the southern hemisphere — Africa and South America fit together, India sat against East Africa, North America hugged Europe.',
  'rules.pangaea.tip3': 'Antarctica used to be at the equator-ish. Australia clung to it from below.',

  /* ─── Landmark Quiz ─── */
  'games.landmark.title':          'Landmark Quiz',
  'games.landmark.tagline':        'Know the icon',
  'games.landmark.description':    'A photo of a famous building or monument — recognise it and pin it on the world map.',
  'rules.landmark.goal':           'You see a photo of a famous landmark. Drop a pin on the world map where you think it is.',
  'rules.landmark.step1':          'Take in the photo for a few seconds. Recognise the building, look for context.',
  'rules.landmark.step2':          'When the timer ends, a world map appears.',
  'rules.landmark.step3':          'Drop a pin on the location and submit. Closer pin = more points.',
  'rules.landmark.step4':          'Five levels. Each one shorter and tighter than the last.',
  'rules.landmark.level1':         '30 sec to look · 1 000 km accuracy',
  'rules.landmark.level2':         '20 sec · 500 km',
  'rules.landmark.level3':         '15 sec · 250 km',
  'rules.landmark.level4':         '10 sec · 100 km',
  'rules.landmark.level5':         '5 sec flash · 50 km',
  'rules.landmark.tip1':           'Distinctive shapes (Eiffel, Pyramids) are gimmes — the points come from accurate pinning.',
  'rules.landmark.tip2':           'Less famous landmarks: read context — climate, building style, surroundings.',
  'rules.landmark.tip3':           'Photos come from Wikipedia under CC-BY-SA. Tap the credit chip to see the source.',

  'paywall.title':        "This game is Premium",
  'paywall.text':         "Unlock this game with points you earn as you play.",
  'paywall.cta':          "Join the BETA program",
  'paywall.dismiss':      "Maybe later",

  /* ─── Spot the Landmark ─── */
  'games.spot.title':       "Spot the Landmark",
  'games.spot.tagline':     "Multiple choice",
  'games.spot.description': "A photo of a famous building or monument — pick the right answer from 3-6 options. Endless mode, gets harder each round.",

  'rules.spot.goal':   "Look at the photo, pick the correct landmark from the options. Answer right to keep going — one wrong guess ends the run.",
  'rules.spot.step1':  "Pick a region (World, Europe, Asia…) — the pool is filtered to that continent.",
  'rules.spot.step2':  "A famous landmark photo appears with a question.",
  'rules.spot.step3':  "Tap the correct answer from the options.",
  'rules.spot.step4':  "Keep your streak alive — every level adds a choice (capped at 6) and gets harder.",
  'rules.spot.level1': "L1–L3 · 3–5 choices · just the name",
  'rules.spot.level2': "L4+ · 6 choices · just the name",
  'rules.spot.level3': "L10+ · 6 choices · name + country",
  'rules.spot.level4': "L20+ · 6 choices · name + city + country",
  'rules.spot.level5': "Endless · score scales with depth · one mistake ends the run",
  'rules.spot.tip1':   "Distractors come from the same continent — read carefully.",
  'rules.spot.tip2':   "Iconic shapes (Eiffel, pyramids) are gimmes — points come from making it deep.",
  'rules.spot.tip3':   "Around L10 the country joins the answer; L20 adds the city.",

  "spot.region.title": "Where do you want to play?",
  "spot.region.sub": "Pick a region. Famous landmarks will appear — choose the right answer to keep going.",
  "spot.q.name": "What is this landmark?",
  "spot.q.namecountry": "Name + country?",
  "spot.q.namecity": "Name + city + country?",
  "spot.score": "Score",
  "spot.choices": "choices",
  "spot.correct": "CORRECT",
  "spot.wrong": "WRONG",
  "spot.points": "POINTS",
  "spot.runTotal": "Run total",
  "spot.next": "Next →",
  "spot.youPicked": "You picked",
  "spot.finalScore": "FINAL SCORE",
  "spot.reachedLevel": "You reached level",
  "spot.tryAgain": "Try Again ↺",
  "spot.changeRegion": "Change Region",
  "spot.mainMenu": "Main Menu",

  /* ─── Auth ─── */
  "auth.signIn": "Sign in",
  "auth.eyebrow": "MINDFUL ZEN WORLD",
  "auth.title": "Sign in or create an account",
  "auth.subtitle": "No password — we'll email you a magic link. New here? An account is created on the fly.",
  "auth.send": "Send magic link",
  "auth.sending": "Sending…",
  "auth.invalidEmail": "Please enter a valid email.",
  "auth.sendFailed": "Could not send link. Try again.",
  "auth.checkInbox": "Check your inbox",
  "auth.linkSentTo": "A sign-in link is on its way to",
  "auth.spamHint": "Can't find it? Check your spam folder. The link expires in 1 hour.",
  "auth.gotIt": "Got it",
  "auth.fineprint": "By continuing you agree to our Terms and Privacy Policy.",
  "auth.menu.profile": "My profile",
  "auth.menu.admin": "Admin",
  "auth.menu.signOut": "Sign out",
  "auth.callback.signingIn": "Signing you in…",
  "auth.callback.hold": "Just a second.",
  "auth.callback.welcome": "Welcome aboard",
  "auth.callback.redirecting": "Taking you to the games…",
  "auth.callback.problem": "Something went wrong",

  /* ─── Auth ─── */

  /* ─── Profile ─── */
  "profile.title": "My Profile",
  "profile.totalPoints": "Total points",
  "profile.totalRuns": "Runs played",
  "profile.gamesPlayed": "Games tried",
  "profile.editTitle": "Edit profile",
  "profile.displayName": "Display name",
  "profile.avatar": "Avatar",
  "profile.country": "Country (optional)",
  "profile.countryHint": "Two-letter ISO code, e.g. HU, US, JP. Used for leaderboard flags.",
  "profile.save": "Save changes",
  "profile.saving": "Saving…",
  "profile.saved": "Saved",
  "profile.nameTooShort": "Display name must be at least 2 characters.",
  "profile.perGame": "Best per game",
  "profile.noRuns": "No games played yet — head back to the menu and pick one.",

  /* ─── Profile ─── */

  /* ─── Gating + Anon limit ─── */
  "common.locked": "LOCKED",
  "common.needPoints": "NEED {n} PTS",
  "locked.pill": "LOCKED",
  "locked.title": "{game} is locked",
  "locked.text": "You're {remaining} points away from unlocking {game}. Keep playing the games you have access to — every run earns points toward the next unlock.",
  "locked.dismiss": "Got it",
  "spot.anon.playsLeft": "{n} free plays left — sign in to keep going.",
  "spot.anon.title": "You've used your free plays",
  "spot.anon.text": "You've played {used} out of {limit} free games. Sign in to keep going — it's free, no password, just an email magic link. Your score will start counting toward your profile.",
  "spot.anon.signIn": "Sign in to continue →",
  "spot.anon.back": "Back to menu",

  /* ─── Gating + Anon limit ─── */

  /* ─── Next game banner ─── */
  "rules.next.upcoming": "NEXT UP",
  "rules.next.unlocked": "NEXT — UNLOCKED",
  "rules.next.unlockedHint": "You have enough points — head back to the menu and dive in.",
  "rules.next.needMore": "{remaining} pts to unlock — keep playing this game to earn more.",
  "rules.next.signedOut": "Earn {threshold} points to unlock — sign in to start counting.",
  "rules.next.premiumHint": "Unlocked with the Premium tier — coming with the Android beta.",

  /* ─── Next game banner ─── */

  /* ─── Audio Atlas ─── */
  'games.audio.title':       "Audio Atlas",
  'games.audio.tagline':     "Flag + anthem",
  'games.audio.description': "A national anthem plays while the country\'s flag is shown. Pin the capital on the map.",

  'rules.audio.goal':   "You hear a national anthem and see the country\'s flag. Pin the capital on the world map as accurately as you can.",
  'rules.audio.step1':  "Pick a region. The pool is filtered to that continent.",
  'rules.audio.step2':  "The anthem plays automatically. The flag stays on screen the whole time.",
  'rules.audio.step3':  "When the timer hits zero, a world map appears. Drop a pin on the capital city.",
  'rules.audio.step4':  "Pass each level by landing inside the distance threshold. Higher levels = shorter listen window.",
  'rules.audio.level1': "10 sec listen · within 1 000 km",
  'rules.audio.level2': "8 sec · 500 km",
  'rules.audio.level3': "6 sec · 250 km",
  'rules.audio.level4': "4 sec · 100 km",
  'rules.audio.level5': "3 sec flash · 50 km",
  'rules.audio.tip1':   "Recognising the flag is the easy part — knowing exactly where the capital sits is the real test.",
  'rules.audio.tip2':   "Some capitals aren\'t the largest city (Brasília, Canberra, Ottawa, Pretoria) — careful.",
  'rules.audio.tip3':   "Anthems vary in tempo and instrumentation; that helps if the flag is one you don\'t know.",

  "audio.region.title": "Where do you want to listen?",
  "audio.region.sub": "Pick a region. You'll hear a national anthem and see the country's flag — pin the capital on the map.",
  "audio.empty.title": "No audio clips available yet",
  "audio.empty.text": "No anthems available yet — we're curating the pool. Check back soon for new countries to identify.",
  "audio.listen.hint": "Recognise the flag and anthem? Pin the country\'s capital on the map.",
  "audio.listen.skip": "I know enough →",
  "audio.submit.ready": "Submit guess →",
  "audio.submit.empty": "Click on the map to drop a pin",
  "audio.changeRegion": "Change Region",

  /* ─── Empire ─── */
  "profile.empire.title": "My Empire",
  "profile.empire.empty": "Identify a country in Audio Atlas or Landmark Quiz to claim it. Your empire grows with every correct answer.",

  /* ─── Empire ─── */

  /* ─── Boost / Shop ─── */
  "boost.title": "Skip the grind",
  "boost.tagline": "Buy points, unlock games faster",
  "boost.description": "Don't want to wait to level up? Three packs from €2.99. Points roll into your balance instantly and count toward every unlock.",
  "boost.cta": "Buy points",
  "shop.title": "Point shop",
  "shop.sub": "Skip the grind",
  "shop.buy": "Buy",
  "shop.opening": "Opening…",
  "shop.success": "Payment confirmed — points credited within seconds.",
  "shop.cancel": "Checkout cancelled — no charge made.",
  "shop.fineprint": "One-time purchase via Stripe. Points are added to your balance instantly after payment confirmation. No subscription, no auto-renewal.",
  "shop.boost.badge": "Popular",
  "shop.power.badge": "Best value",

  /* ─── Boost / Shop ─── */
};

export default en;
